import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link, useSearchParams,useNavigate } from 'react-router-dom';
import SglContext from "../SglContext";
import { set } from "react-ga";
import VideoPlayer from "../videos/VideoPlayer";

function CircuitStandingDetail (props){
    const Sgl = useContext(SglContext)
    const [standings, setStandings] = useState([])
    const [circuit, setCircuit] = useState({})
    const [circuit_id, setCircuit_id] = useState(0)
    const [circuit_division, setCircuit_division] = useState({})
    const [show_name, setShow_name] = useState([])
    const [current_show, setCurrent_show] = useState(localStorage.getItem("show_id"))
    const [loading, setLoading] = useState(true)
    const [userData, setUserData] = useState({})
    const sgl_webservice_people_detail = Sgl.nestApiUrl+'/results/circuitStanding/';
    const user_info_url = Sgl.nestApiUrl+'/users/getUser';
    const[searchParam,setSearchParam]=useSearchParams()
    const [selection_method,setSelection_method] = useState()
    const navigate = useNavigate();


useEffect(() => { // ComponentDidMount
    getCircuitStandingDetails()
}, [])
  
    function getCircuitStandingDetails(){
      getUserData();
      axios.all([
        axios.get(sgl_webservice_people_detail+searchParam.get('div_id'),{
            params : {
                circuit_id: searchParam.get('circuit_id'),
                show_id: current_show,
                customer_id: Sgl.company_id
            }
          }) 
        ]).then(axios.spread((res) => {
            setStandings(res.data.standings)
            setCircuit(res.data.circuit)
            setCurrent_show(res.data.show_id)
            setCircuit_id(res.data.circuit_id)
            setCircuit_division(res.data.circuit_division)
            setShow_name(res.data.show_name)
            setSelection_method(res.data.circuit_division.standingsselectionmethod)
            setLoading(false)
            document.title = "Results for " + res.data.show_name;
            Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+res.data.show_id+'/circuitstandings/detail/circuit/'+res.data.circuit_id+'/division/'+searchParam.get('div_id'));
            Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+res.data.show_id+'/circuitstandings/detail/circuit/'+res.data.circuit_id+'/division/'+searchParam.get('div_id'));
          }))
    }

    function getUserData(){
      axios.get(user_info_url)
      .then((response) => {
        if(response.data.user && response.data.user != null){
        setUserData(response.data.user)
        }else{
        }
      }, (error) => {
      });
    }

    function onShowChange(show_id) {
      localStorage.setItem('show_id', show_id);
    //   window.location.href=page_url;
    }
        if(loading) {
          return null;
        }
        
        return(
          <div className="section-to-print">
             <section className="search-area">
              <h2 className="sgl-h2">Results for {show_name}</h2>
              <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br/>
              <div><span className='sponsor_text'><b>Standings:</b></span> <Link className="link_color" to onClick={(e)=>{e.preventDefault();navigate('/circuit-standings/')}}>{circuit.name} : {circuit_division.name}</Link></div>
              <div><span className='sponsor_text'><b>Calculated at:</b></span> {circuit_division.lastmodified_date_time_formatted}</div>
              <div><span className='sponsor_text'><b>Calculation Method:</b></span> {circuit_division.standingsbasedon}: {circuit_division.standingscalmethod == 'Linear'?'From Classes':circuit_division.standingscalmethod}</div>
              <div className='sgl-mb-5'><span className='sponsor_text'><b>Based on:</b></span> {circuit_division.standingsselectionmethod}</div>

              { (standings.length > 0) ?
              <div className="">
                <table className="table table-striped table-hover">
                  <thead className="classes-header">                  
                  
                  <tr className="sgl-primary-header">
                    <th className='center-align'>Position</th>
                    {(!((selection_method == "Trainer")||(selection_method == "Owner") ||(selection_method == "Rider"))) &&
                      <th>Entries</th>
                    }
                    {((selection_method == "Horse")||(selection_method == "Horse/Rider")) &&
                      <th>Horse</th>
                    }
                    {((selection_method == "Horse")||(selection_method == "Rider")||(selection_method == "Horse/Rider")) &&
                      <th>Rider</th>
                    }
                    {(selection_method == "Owner") &&
                        <th>Owner</th>
                    }
                    {(selection_method == "Trainer") &&
                        <th>Trainer</th>
                    }
                    {((selection_method == "Trainer")||(selection_method == "Owner") ||(selection_method == "Rider")) &&
                      <th>Entries</th>
                    }
                    {(circuit_division.standingsbasedon=="Dollar")?
                          <th className='right-align'>Prize $</th>
                      :
                          <th className='center-align'>Points</th>
                    }
                  </tr>
                  </thead>
                  <tbody>
                  {
                    standings.map((data,index) => {
                        var p_id = data.rider_id;
                        if (selection_method=="Owner")
                          p_id = data.owner_id;
                        else if (selection_method=="Trainer")
                          p_id = data.trainer_id;                              

                        return(
                        <tr className="sgl-anchor" onClick={(e)=>{e.preventDefault();navigate('/circuitstanding/detail/points?div_id='+circuit_division.circuit_division_id+'&circuit_id='+circuit_id+'&hid='+data.horse_id+'&pid='+p_id+'&sid='+current_show)}}>
                          <td className='center-align' nowrap="nowrap"><a>{data.position}</a></td>
                          {(!((selection_method == "Trainer")||(selection_method == "Owner") ||(selection_method == "Rider"))) &&
                            <td><a>{data.entry_numbers}</a></td>
                          }
                          {((selection_method == "Horse")||(selection_method == "Horse/Rider")) &&
                            <td><a>{data.horse_name}</a></td>
                          }
                          {((selection_method == "Horse")||(selection_method == "Rider")||(selection_method == "Horse/Rider")) &&
                            <td><a>{data.rider_name}</a></td>
                          }
                          {(selection_method == "Owner") &&
                            <td><a>{data.owner_name}</a></td>
                          }
                          {(selection_method == "Trainer") &&
                            <td><a>{data.trainer_name}</a></td>
                          }
                          {((selection_method == "Trainer")||(selection_method == "Owner") ||(selection_method == "Rider")) &&
                            <td><a>{data.entry_numbers}</a></td>
                          }
                          {(circuit_division.standingsbasedon=="Dollar")?
                            <td className='right-align'><a>{(Number(data.points).toFixed(2))?'$'+Number(data.points).toFixed(2):"-"}</a></td>
                            :
                            <td className='center-align'><a>{(Number(data.points).toFixed(2))?Number(data.points).toFixed(2):"-"}</a></td>
                          }
                        </tr>
                      )
                    })
                  }
                  </tbody>
                </table>
              </div>
              : 
                <table>
                  <tbody>
                    <tr>
                      <td>No records found.</td>
                    </tr>
                  </tbody>
                </table>
              }
              <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
            </section>
          </div>
        )
}
export default CircuitStandingDetail